module.exports = __webpack_public_path__ + "img/story-android.ebbd4593.svg";